/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Byte4Word200ResponseResultData,
    Byte4Word200ResponseResultDataFromJSON,
    Byte4Word200ResponseResultDataFromJSONTyped,
    Byte4Word200ResponseResultDataToJSON,
} from './Byte4Word200ResponseResultData';

/**
 * byte4_word_api の 200 レスポンス
 * @export
 * @interface Byte4Word200Response
 */
export interface Byte4Word200Response {
    /**
     * result が存在するかどうか
     * @type {boolean}
     * @memberof Byte4Word200Response
     */
    result: boolean;
    /**
     * 
     * @type {Byte4Word200ResponseResultData}
     * @memberof Byte4Word200Response
     */
    resultData: Byte4Word200ResponseResultData;
    /**
     * ステータスコードの文字列
     * @type {string}
     * @memberof Byte4Word200Response
     */
    status: string;
}

export function Byte4Word200ResponseFromJSON(json: any): Byte4Word200Response {
    return Byte4Word200ResponseFromJSONTyped(json, false);
}

export function Byte4Word200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Byte4Word200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': json['result'],
        'resultData': Byte4Word200ResponseResultDataFromJSON(json['result_data']),
        'status': json['status'],
    };
}

export function Byte4Word200ResponseToJSON(value?: Byte4Word200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
        'result_data': Byte4Word200ResponseResultDataToJSON(value.resultData),
        'status': value.status,
    };
}

